export default __webpack_public_path__ + "static/media/beta-watermark.752ab3c2.svg";